import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nonogram',
  templateUrl: './nonogram.component.html',
  styleUrls: ['./nonogram.component.scss']
})
export class NonogramComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
